import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, ParamMap } from '@angular/router';
import { FormGroup, FormControl, FormBuilder, NgForm } from '@angular/forms';
import { ApiPartnerService } from '@app/api/api-partner.service';


@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.css']
})
export class NotificationComponent implements OnInit {

  textSearch = new FormControl('');
  workorderList : any = {};
  ServiceList: any = [];
  ViewSTB: any = {};
  paging : any = {};
  Billingtype : any = [];
  Servicetype : any = [];

  daynotif : any = [];
  
  fs : string;
  msearch : string;
  //paging_link : any = [];
  page_self = [];
  page_next = [];
  page_prev = [];
  meta = [];
  last_index : number;
  first_index : number;
  total_count : number;
  querySearch = false;
  searching = false;
  dataempty = true;
  currentParams = {};
  queryParams = '';
  searchQueryParams = '';
  href='';
  alert_act='';
  alert_actmsg='';

  isOne= false;
  alert_failed = false
  alert_success = false

  table_load = true

	constructor(
		public partnerService: ApiPartnerService,
		private route: ActivatedRoute,
		private fb: FormBuilder
	) { }

	ngOnInit() {
		this.loadStart();

	}


	loadStart() {
	this.route.queryParams
	  //.filter(params => params.order)
	  .subscribe(params => {
	    console.log(params); // {order: "popular"}

	    //this.order = params.order;
	    //console.log(this.order); // popular

	    if (params.search != '' && params.search != undefined ){
	      console.log('search');
	      console.log(params.search);
	     this.msearch = params.search; 
	     this.querySearch = true;
	    

	     this.currentParams = params;
	     this.queryParams = '?'+this.queryStr(params);
	     this.loadService(this.queryParams);
	    
	    }else{
	      this.querySearch = false;
	      this.currentParams = params;

	      this.queryParams = '?'+this.queryStr(params);
	      console.log(this.queryParams);
	      console.log(this.queryStr(params));
	      /* pagination */
	      this.loadService(this.queryParams);
	    }
	  });

	}

	queryStr(options: any){
	    let params = new URLSearchParams();
	    for(let key in options){
	        params.set(key, options[key]) 
	    }
	    return params.toString();
	  }

	// Issues list
	loadService(params: any) {
		this.table_load = true;
		return this.partnerService.Getnotificationservice(params).subscribe((output: any) => {
		console.log(output);
		  this.ServiceList = output.data;

		  this.table_load = false

		  // start pagination
		  this.paging = output.pagex;
		  this.page_self = output.pagex.self;
		  this.page_next = output.pagex.next;
		  this.page_prev = output.pagex.prev;
		  this.meta = output.meta;
		  this.total_count = this.meta['totalCount'];
		  let self = this.page_self['page'];
		  if ( self * this.meta['perPage'] < this.meta['totalCount']){
		    this.last_index = (self * this.meta['perPage']);
		  }else{
		    this.last_index = this.meta['totalCount'];
		  }
		  
		  this.first_index = ((self-1)*this.meta['perPage'])+1;
		  //end pagination
		  
		  // console.log(this.paging);
		  //this.paging_link = this.ServiceList.paging.links;
		})
	}
  
  isnullnotif(item)
  {
  	if (!item.notif){
  		return true;
  	}else{
  		return false;
  	}
  }

  iscronactive(item,code)
  {
  	if ( item[code] == null )
  	{
  		return false;
  	}

  	if (item[code]['statuscron'] == 1){
  		return false;
  	}else{
  		return true;
  	}
  }

  //notif reminder
  addCronNotif(item,notifcode,i)
  {
  	
  	let notif = this.getNotifByCode(item,notifcode);
  	let actiondate = '';
  	let notifid = 0;
  	let code = '';
  	if ( notif == null )
  	{
  		actiondate = '';

  	}else{
  		actiondate = notif['actiondate'];
  		notifid = notif['id'];
  		code = notif['notifcode'];
  	}

  	
  	let params = {
		"notifcode":code,
		"customerid":item.customerid,
		"notiftype": "reminder",
		"actiondate": actiondate,
		"customerserviceid": item.customerserviceid,
		"notifid":notifid
	};

  	return this.partnerService.PostAddCronNotification(params).subscribe((output: any) => {
		console.log(output);
		alert('ok');
	});

  	
  }

  addNotif(item,code,i)
  {
  		let params = {
						"notifcode":code,
						"customerid":item.customerid,
						"notiftype": "reminder",
						"customerserviceid": item.customerserviceid
					};

  		return this.partnerService.PostAddNotification(params).subscribe((output: any) => {
			console.log(output);
			if ( output['data'][item.customerserviceid]['-5'] != undefined) {
				this.ServiceList[i]['notif5'] = output['data'][item.customerserviceid]['-5'];
			}

			if ( output['data'][item.customerserviceid]['-5'] != undefined) {
				this.ServiceList[i]['notif10'] = output['data'][item.customerserviceid]['-10'];
			}
			if ( output['data'][item.customerserviceid]['-5'] != undefined) {
				this.ServiceList[i]['notif15'] = output['data'][item.customerserviceid]['-15'];
			}
		  
		})
  }



  getNotif5(item)
  {
  	if (item.notif5 == null){
  		return '0000-00-00';
  	}else{
  		return item.notif5.actiondate;
  	}
  }

  getNotif10(item)
  {
  	if (item.notif10 == null){
  		return '0000-00-00';
  	}else{
  		return item.notif10.actiondate;
  	}
  }

  getNotif15(item)
  {
  	if (item.notif15 == null){
  		return '0000-00-00';
  	}else{
  		return item.notif15.actiondate;
  	}
  }

  getNotifByCode(item,notifcode){
  	return item[notifcode];
  }

  SentNotif(item)
  {
    if ( !confirm('Yakin mengirim notif ke pelanggan ?')){
      return;
    }

    let params = {id:item.customerserviceid};

    return this.partnerService.PostSendNotification(params).subscribe((output: any) => {
      console.log(output);
     
    });
  }

  availableNotif(item)
  {
    return ( parseInt(item.berakhir) < 0 );
  }


  setcronnotif(item,i){
    if ( !confirm('Add Notifikasi di '+ this.daynotif[item.customerserviceid] + ' ? '))
    {
      return;
    }

    this.addNotif(item,this.daynotif[item.customerserviceid],i);
  }

  showcontent(item)
  {
    if ( item.cronnotif ){
      return item.cronnotif['content'];
    }else{
      return '';
    }
  }

  search()
  {
    //this.queryParams = '?'+this.queryStr(params);
    this.queryParams = '?fs='+this.fs+'&search='+this.msearch;
    this.loadService(this.queryParams);
  }

}
